module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-Regular.0db7e56.woff";